/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailshint2Inputs */

const en_companydetailshint2 = /** @type {(inputs: Companydetailshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your billing details are still missing.`)
};

const de_companydetailshint2 = /** @type {(inputs: Companydetailshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Rechnungsdaten fehlen noch.`)
};

/**
* | output |
* | --- |
* | "Your billing details are still missing." |
*
* @param {Companydetailshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailshint2 = /** @type {((inputs?: Companydetailshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailshint2(inputs)
	return de_companydetailshint2(inputs)
});
export { companydetailshint2 as "companyDetailsHint" }